import { Route, Routes } from "react-router-dom";
import CreateCompany from "../pages/companies/CreateCompany";
import ShowRepresentative from "../pages/companies/ShowRepresentative";
import CreateRepresentative from "../pages/companies/CreateRepresentative";
import CreatePlanes from "../pages/permissions/CreatePlanes";
import ListRoles from "../pages/permissions/ListRoles";
import ListPermissions from "../pages/permissions/ListPermissions";
import ListPlanes from "../pages/permissions/ListPlanes";
import ListCompanies from "../pages/companies/ListCompanies";
import CreateRoles from "../pages/permissions/CreateRoles";
import ShowRole from "../pages/permissions/ShowRole";
import ShowPlan from "../pages/permissions/ShowPlan";
import InvoiceForm from "../pages/Pos/InvoiceForm";
import UserRegistrationForm from "../pages/permissions/UserRegistrationForm";
import EnhancedUserList from "../pages/permissions/EnhancedUserList";


export default function Display() {
    // CreatePlanes
    return (
        <Routes>
            {/*Roles, permisions and plans*/}
            <Route path='rpp/createuser' element={<UserRegistrationForm />} />
            <Route path='rpp/showusers' element={<EnhancedUserList />} />
            <Route path='rpp/createplanes' element={<CreatePlanes />} />
            <Route path='rpp/createroles' element={<CreateRoles />} />
            <Route path='rpp/listpermissions' element={<ListPermissions />} />
            <Route path='rpp/listroles' element={<ListRoles />} />
            <Route path='rpp/showrole/:id' element={<ShowRole />} />
            <Route path='rpp/listplans' element={<ListPlanes />} />
            <Route path='rpp/showplan/:id' element={<ShowPlan/>} />
            

            <Route path='com/createcompany' element={<CreateCompany />} />
            <Route path='com/showcompany/:id' element={<ShowRepresentative />} />
            <Route path='com/listcompanies' element={<ListCompanies />} />
            <Route path='com/createrepresentative/:id' element={<CreateRepresentative />} />

            {<Route path='rpp/invoice' element={<InvoiceForm />} />}
        </Routes>
    );
}